// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"d9250895","309":"0c0bd658","848":"268b013e"}[chunkId] + ".chunk.js";
};